import { render, staticRenderFns } from "./preguntas-frecuentes.vue?vue&type=template&id=298b51d8"
import script from "./preguntas-frecuentes.vue?vue&type=script&lang=js"
export * from "./preguntas-frecuentes.vue?vue&type=script&lang=js"
import style0 from "./preguntas-frecuentes.vue?vue&type=style&index=0&id=298b51d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports